export default {"src":"/_next/static/media/chives.ed693a8f.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};